import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { handleSignIn } from '../../Scripts/SignIn';

export default function NavMenu({ loggedInUser, selectedMenu, onNavigationClick, onHamburgerClick }) {
    const params = useParams();
    const navigate = useNavigate();
    const projectId = params.projectId;
    const siteId = params.siteId;

    function handleNavigationClick(event) {
        var name = event.currentTarget.getAttribute("name");

        if (name === "b2r" && !loggedInUser?.isAuthenticated) {
            handleSignIn("/b2r");
        }
        else {
            onNavigationClick(name);
        }
        navigate(`/${name}`);
    }

    let navItems;
    if (loggedInUser?.isAuthenticated && loggedInUser?.isDocShareUser) {
        navItems = (<li name="b2r" className={selectedMenu === "b2r" ? "selected" : ""} onClick={handleNavigationClick}>
            <i className="dhicon-multi-house" />
            <span className="navMenuItemDesc">Projects</span>
        </li>);
    }
    /*
    else {
        navItems = (<li name="docportal" className={selectedMenu === "docportal" ? "selected" : ""} onClick={handleNavigationClick}>
            <i className="dhicon-docs" />
            <span className="navMenuItemDesc">Portal</span>
        </li>);
    }
    */

    var hamburgerItem = onHamburgerClick && (<li className="hamburger" onClick={onHamburgerClick}>
        <i className="dhicon-menu-hamburger" />
    </li>);

    let navList = (<ul>{hamburgerItem}{navItems}</ul>);

    return (<div className="navigation-menu">{navList}</div>);
}